import { getTrackerParams as getBaseTrackerParams } from 'scenes/SmartRules/utils/getTrackerParams';
import {
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_CLUSTERS,
  FILTER_AFFILIATES,
  FILTER_COUNTRIES,
  FILTER_OWNERS,
  FILTER_LABELS,
  FILTER_PLATFORMS,
  FILTER_CLIENTS,
  FILTER_TRAFFIC_TYPE,
  FILTER_INFLUENCER_CHANNEL_SOCIAL_MEDIA_PLATFORMS,
  FILTER_CREATIVE_TYPES,
  FILTER_CREATIVE_INCLUDED_TAGS,
  FILTER_CREATIVE_LANGUAGES,
  FILTER_CREATIVE_MEDIA_TYPES,
  FILTER_CREATIVE_ORIENTATIONS,
  FILTER_CREATIVE_STATUSES,
} from 'scenes/Trackers/Tracker/constants';

import { clean } from '../utils';

const getAdvertisingFilters = ({
  affiliates,
  applications,
  clients,
  clusters,
  countries,
  labels,
  networks,
  owners,
  platforms,
  socialMediaPlatforms,
  trafficType,
} = {}) =>
  clean({
    [FILTER_AFFILIATES]: affiliates,
    [FILTER_APPLICATIONS]: applications,
    [FILTER_CLIENTS]: clients,
    [FILTER_CLUSTERS]: clusters,
    [FILTER_COUNTRIES]: countries,
    [FILTER_LABELS]: labels,
    [FILTER_NETWORKS]: networks,
    [FILTER_OWNERS]: owners,
    [FILTER_PLATFORMS]: platforms,
    [FILTER_INFLUENCER_CHANNEL_SOCIAL_MEDIA_PLATFORMS]: socialMediaPlatforms,
    [FILTER_TRAFFIC_TYPE]: trafficType,
  });

const getCreativesFilters = ({
  creativeTypes,
  languages,
  mediaTypes,
  orientations,
  tags,
  statuses,
} = {}) =>
  clean({
    [FILTER_CREATIVE_TYPES]: creativeTypes,
    [FILTER_CREATIVE_LANGUAGES]: languages,
    [FILTER_CREATIVE_MEDIA_TYPES]: mediaTypes,
    [FILTER_CREATIVE_ORIENTATIONS]: orientations,
    [FILTER_CREATIVE_INCLUDED_TAGS]: tags,
    [FILTER_CREATIVE_STATUSES]: statuses,
  });

export const getTrackerParams = (data) => {
  let { filtersCollection = [], ...baseParams } = getBaseTrackerParams(data);

  return {
    ...baseParams,
    filtersCollection: filtersCollection.map((filters) => ({
      ...filters,
      ...getAdvertisingFilters(data?.target),
      ...getCreativesFilters(data?.creativesTarget),
    })),
  };
};
